import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { apiScope, config } from '../../config';

function DevLogin() {
  if (localStorage.getItem('atlas-dev-user')) {
    return <Navigate to="/maps" replace />;
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/grs-atlas-logo.png" alt="GRS Atlas" className="login-logo" />
        <p>Development auth is enabled. Continue as a local admin.</p>
        <button
          type="button"
          className="btn"
          onClick={() => {
            localStorage.setItem('atlas-dev-user', 'dev@guidedreach.com');
            localStorage.setItem('atlas-dev-roles', 'Atlas.Admin');
            window.location.href = '/maps';
          }}
        >
          Continue (Dev)
        </button>
      </div>
    </div>
  );
}

function EntraLogin() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect
  ) {
    return <div className="empty">Signing you in…</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/maps" replace />;
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/grs-atlas-logo.png" alt="GRS Atlas" className="login-logo" />
        <p>Sign in with your Guided Reach Solutions Microsoft account.</p>
        <button
          type="button"
          className="btn"
          onClick={() =>
            void instance.loginRedirect({
              scopes: [apiScope],
            })
          }
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

export function LoginPage() {
  if (config.devAuth) return <DevLogin />;
  return <EntraLogin />;
}
